/**
 * One-Time Token Authentication Methods
 *
 * Defines the passwordless authentication methods supported by OTT flow.
 * Used in magic link, SMS verification, and email code authentication.
 */
export const OttAuthMethod = {
    /** Magic link sent via email */
    MAGIC_LINK: 'magic-link',
    /** Verification code sent via SMS */
    SMS: 'sms',
    /** Verification code sent via email */
    EMAIL_CODE: 'email-code',
};
//# sourceMappingURL=ott-auth-method.enum.js.map